import type { KinerjaStatusOriginal } from 'types/kinerja'

/**
 * Check if the status is a valid perencanaan status for Pamong
 * @param status - The status to check
 * @returns True if the status is a valid perencanaan status for Pamong, false otherwise
 */
export function isValidPerencanaanStatus(
  status: unknown
): status is KinerjaStatusOriginal {
  return (
    typeof status === 'string' &&
    [
      'NOT_FOUND',
      'DRAFT',
      'WAITING_APPROVAL',
      'APPROVED',
      'REVISED',
      'READY',
    ].includes(status)
  )
}
